/**
 * @generated SignedSource<<ed977e87ab227e76a71245502b4e4270>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AttendeeFilterAttendeesQuery$variables = {
  query?: string | null;
};
export type AttendeeFilterAttendeesQuery$data = {
  readonly recordingsAttendees: ReadonlyArray<{
    readonly email: string;
    readonly fullName: string | null;
    readonly image: string | null;
  }>;
};
export type AttendeeFilterAttendeesQuery = {
  response: AttendeeFilterAttendeesQuery$data;
  variables: AttendeeFilterAttendeesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "query"
      }
    ],
    "concreteType": "RecordingAttendee",
    "kind": "LinkedField",
    "name": "recordingsAttendees",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AttendeeFilterAttendeesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AttendeeFilterAttendeesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c442f3c311fcd885adcf08a87eeaf4fb",
    "id": null,
    "metadata": {},
    "name": "AttendeeFilterAttendeesQuery",
    "operationKind": "query",
    "text": "query AttendeeFilterAttendeesQuery(\n  $query: String\n) {\n  recordingsAttendees(search: $query) {\n    email\n    fullName\n    image\n  }\n}\n"
  }
};
})();

(node as any).hash = "f451811b5abb63fdeab6f1029512a3af";

export default node;
